import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  Box,
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  NativeSelect,
  Paper,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import SchoolIcon from "@mui/icons-material/School";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import WysiwygIcon from "@mui/icons-material/Wysiwyg";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import InventoryIcon from "@mui/icons-material/Inventory";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import LineChart from "../../components/LineChart";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PaidIcon from "@mui/icons-material/Paid";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import PanoramaIcon from "@mui/icons-material/Panorama";
import { useNavigate } from "react-router-dom";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import FiberNewIcon from "@mui/icons-material/FiberNew";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import {
  useLazyGetEarningQuery,
  useLazyGetDashboArdApiQuery,
  useLazyGetGraphUserGraphQuery,
  useLazyExportUserCsvQuery,
  useLazyExportTutorCsvQuery,
  useLazyExportBookingCsvQuery,
  useLazyExportRevenueCsvQuery,
  useLazyGetTheBookingGraphQuery,
  useLazyGetGraphTutorGraphQuery,
  useLazyGetTheFollowerGraphQuery,
  useLazyGetTheViewGraphQuery,
} from "../../services/dashboard";
import { errorToast, successToast } from "../../helpers";
import GenersTab from "./GenersTab";
import ClassesTab from "./ClassesTab";
import TutorsTab from "./TutorsTab";
import { CONTENT_TYPE, DASHBOARD_TYPE } from "../../helpers/constants/enums";
import {
  CheckCircle,
  Comment,
  Equalizer,
  Forum,
  Group,
  MonetizationOn,
  People,
  PlayCircle,
  PostAdd,
  QuestionMark,
  ReportProblem,
  School,
  Star,
  ThumbUp,
  TrendingUp,
  Visibility,
} from "@mui/icons-material";
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#204e33" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const DashBoard = () => {
  const [exportUserCsv] = useLazyExportUserCsvQuery();
  const [exportTutorCsv] = useLazyExportTutorCsvQuery();
  const [exportBookingCsv] = useLazyExportBookingCsvQuery();
  const [exportRevenue] = useLazyExportRevenueCsvQuery();
  const [selectedType1, setSelectedType1] = useState<string>("weekly");
  //  const [selectedType2, setSelectedType2] = useState<string>("weekly");
  const [selectedType3, setSelectedType3] = useState<string>("weekly");
  const [selectedType4, setSelectedType4] = useState<string>("weekly");
  const [selectedType5, setSelectedType5] = useState<string>("");

  const [bookingGraph, setbookingGraph] = useState<any>([]);
  const [followerGraph, setFollowerGraph] = useState<any>([]);
  const [viewsGraph, setViewsGraph] = useState<any>([]);
  const [tutorGraph, settutorGraph] = useState<any>([]);
  const [value, setValue] = useState<number>(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [TutorGraph] = useLazyGetGraphTutorGraphQuery();
  const [BookingsGraph] = useLazyGetTheBookingGraphQuery();
  const [FollowerGraph] = useLazyGetTheFollowerGraphQuery();
  const [ViewGraph] = useLazyGetTheViewGraphQuery();
  const handleExportUserCsv = async () => {
    try {
      const res = await exportUserCsv({
        type: selectedType1,
        query: "csv",
      }).unwrap();

      const parsedRes = typeof res === "string" ? JSON.parse(res) : res;

      if (parsedRes && parsedRes.message && parsedRes.message.s3Location) {
        window.open(parsedRes.message.s3Location);
        successToast("CSV exported successfully");
      } else {
        errorToast("Error: s3Location not found in response");
      }
    } catch (error: any) {
      errorToast(error?.message);
    }
  };
  const handleExportTutorCsv = async () => {
    try {
      const res = await exportTutorCsv({
        type: selectedType2,
        query: "csv",
      }).unwrap();

      const parsedRes = typeof res === "string" ? JSON.parse(res) : res;

      if (parsedRes && parsedRes.message && parsedRes.message.s3Location) {
        window.open(parsedRes.message.s3Location);
        successToast("CSV exported successfully");
      } else {
        errorToast("Error: s3Location not found in response");
      }
    } catch (error: any) {
      errorToast(error?.message);
    }
  };
  const handleExportBookingCsv = async () => {
    try {
      const res = await exportBookingCsv({
        type: selectedType3,
        query: "csv",
      }).unwrap();

      const parsedRes = typeof res === "string" ? JSON.parse(res) : res;

      if (parsedRes && parsedRes.message && parsedRes.message.s3Location) {
        window.open(parsedRes.message.s3Location);
        successToast("CSV exported successfully");
      } else {
        errorToast("Error: s3Location not found in response");
      }
    } catch (error: any) {
      errorToast(error?.message);
    }
  };

  const handleExportRevenueCsv = async () => {
    try {
      const res = await exportRevenue({
        type: selectedType,
        query: "csv",
      }).unwrap();

      const parsedRes = typeof res === "string" ? JSON.parse(res) : res;

      if (parsedRes && parsedRes.message && parsedRes.message.s3Location) {
        successToast("CSV exported successfully");
        window.open(parsedRes.message.s3Location);
      } else {
        errorToast("Error: s3Location not found in response");
      }
    } catch (error: any) {
      errorToast(error?.message);
    }
  };

  const [user, serUser] = useState<any>([]);
  const [selectedType2, setSelectedType2] = useState<string>("weekly");
  const [selectedType6, setSelectedType6] = useState<string>("weekly");
  const [selectedType7, setSelectedType7] = useState<string>("weekly");
  const fetchUsersGraph = async (type: string) => {
    try {
      const response = await Usergraph(type).unwrap();
      const formattedData = response?.data?.map((item: any) => ({
        label: item.name,
        value: item.value,
      }));
      serUser(formattedData);
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  useEffect(() => {
    fetchUsersGraph(selectedType2);
  }, [selectedType2]);

  const graphUsersData = {
    labels: user?.map((item: any) => item.label),
    datasets: [
      {
        label: "Total Users",
        data: user?.map((item: any) => item.value),
        borderColor: "#05a633",
        backgroundColor: "#05a633",
      },
    ],
  };

  const fetchFollowerGraph = async (type: string) => {
    try {
      const response = await FollowerGraph(type).unwrap();
      const formattedData = response?.data?.map((item: any) => ({
        label: item.name,
        value: item.value,
      }));
      setFollowerGraph(formattedData);
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
  const fetchViewsGraph = async (type: string) => {
    try {
      const response = await ViewGraph(type).unwrap();
      const formattedData1 = response?.data["1"]?.map((item: any) => ({
        label: item?.name,
        value: item?.value,
      }));
      const formattedData2 = response?.data["2"]?.map((item: any) => ({
        label: item?.name,
        value: item?.value,
      }));
      const formattedData3 = response?.data["3"]?.map((item: any) => ({
        label: item?.name,
        value: item?.value,
      }));
      const formattedData4 = response?.data["4"]?.map((item: any) => ({
        label: item?.name,
        value: item?.value,
      }));
      // (FORUM = 1),
      //   (SHORT_VIDEO = 2),
      //   (TEASER_VIDEO = 3),
      //   (POST = 4),
      setViewsGraph({
        FORUM: formattedData1,
        SHORT_VIDEO: formattedData2,
        TEASER_VIDEO: formattedData3,
        POST: formattedData4,
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
  const fetchBookingGraph = async (type: string) => {
    try {
      const response = await BookingsGraph(type).unwrap();
      const formattedData = response?.data?.map((item: any) => ({
        label: item.name,
        value: item.value,
      }));
      setbookingGraph(formattedData);
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const fetchTutorsGraph = async (type: string) => {
    try {
      const response = await TutorGraph(type).unwrap();
      const formattedData = response?.data?.map((item: any) => ({
        label: item.name,
        value: item.value,
      }));
      settutorGraph(formattedData);
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
  const handleChange1 = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newType = event.target.value as string;
    setSelectedType1(newType);
  };
  const handleChange2 = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newType = event.target.value as string;
    setSelectedType2(newType);
  };
  const handleChange3 = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newType = event.target.value as string;
    setSelectedType3(newType);
  };
  const handleChange6 = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newType = event.target.value as string;
    setSelectedType6(newType);
  };
  const handleChange7 = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newType = event.target.value as string;
    setSelectedType7(newType);
  };
  const handleChange4 = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newType = event.target.value as string;
    setSelectedType4(newType);
  };
  const handleChange5 = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newType = event.target.value as string;
    setSelectedType5(newType);
  };
  useEffect(() => {
    fetchEarningGraph(selectedType4);
  }, [selectedType4]);
  useEffect(() => {
    fetchBookingGraph(selectedType3);
  }, [selectedType3]);
  useEffect(() => {
    fetchFollowerGraph(selectedType6);
  }, [selectedType6]);
  useEffect(() => {
    fetchViewsGraph(selectedType7);
  }, [selectedType7]);
  useEffect(() => {
    fetchUsersGraph(selectedType1);
  }, [selectedType1]);
  useEffect(() => {
    fetchTutorsGraph(selectedType2);
  }, [selectedType2]);
  const [data, setData] = useState<any>();
  const [earningGraph, setEarningGraph] = useState<any>([]);
  const [EarningGraph] = useLazyGetEarningQuery();

  const [selectedType, setSelectedType] = useState<string>("weekly");
  const fetchEarningGraph = async (type: string) => {
    try {
      const response = await EarningGraph(type).unwrap();
      const formattedData = response?.data.map((item: any) => ({
        label: item.name,
        value: item.value,
      }));
      setEarningGraph(formattedData);
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const [Usergraph] = useLazyGetGraphUserGraphQuery();

  const [dashboard] = useLazyGetDashboArdApiQuery();
  const fetchDashBoard = async () => {
    try {
      const response = await dashboard({
        type: selectedType5,
        dashboardType: value + 1,
      }).unwrap();
      if (response.statusCode === 200) {
        setData(response?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const graphAdvertisersData = {
    labels: tutorGraph?.map((item: any) => item.label),
    datasets: [
      {
        label: "Total Tutors",
        data: tutorGraph?.map((item: any) => item.value),
        borderColor: "#05a633",
        backgroundColor: "#05a633",
      },
    ],
  };

  const graphTransactionsData = {
    labels: earningGraph?.map((item: any) => item.label),
    datasets: [
      {
        label: "Total Revenue",
        data: earningGraph?.map((item: any) => item.value),
        borderColor: "#05a633",
        backgroundColor: "#05a633",
      },
    ],
  };
  useEffect(() => {
    fetchDashBoard();
  }, [selectedType5, value]);
  useEffect(() => {
    fetchEarningGraph(selectedType); // Fetch initial data based on selected type
  }, [selectedType]);

  const graphRevenueData = {
    labels: bookingGraph?.map((item: any) => item.label),
    datasets: [
      {
        label: "Total Bookings",
        data: bookingGraph?.map((item: any) => item.value),
        borderColor: "#05a633",
        backgroundColor: "#05a633",
      },
    ],
  };

  const graphFollowerData = {
    labels: followerGraph?.map((item: any) => item.label),
    datasets: [
      {
        label: "Follower`s",
        data: followerGraph?.map((item: any) => item.value),
        borderColor: "#05a633",
        backgroundColor: "#05a633",
      },
    ],
  };
  const graphViewsData = {
    labels: viewsGraph?.FORUM?.map((item: any) => item.label),
    datasets: [
      {
        label: "Teaser Videos",
        data: viewsGraph?.TEASER_VIDEO?.map((item: any) => item.value),
        borderColor: "#05a633",
      },
      {
        label: "Short Videos",
        data: viewsGraph?.SHORT_VIDEO?.map((item: any) => item.value),
        borderColor: "#1976d2",
      },
      {
        label: "Post",
        data: viewsGraph?.POST?.map((item: any) => item.value),
        borderColor: "#ff9800",
      },
      {
        label: "Forums",
        data: viewsGraph?.FORUM?.map((item: any) => item.value),
        borderColor: "#aa76d2",
      },
    ],
  };
  function formatRevenue(labelValue: number) {
    // Nine Zeroes for Billions
    const num = labelValue?.toFixed(2);
    // const num = 23032493;
    return Math.abs(Number(num)) >= 1.0e9
      ? (Math.abs(Number(num)) / 1.0e9).toFixed(2) + " B"
      : // Six Zeroes for Millions
        Math.abs(Number(num)) >= 1.0e6
        ? (Math.abs(Number(num)) / 1.0e6).toFixed(2) + " M"
        : // Three Zeroes for Thousands
          Math.abs(Number(num)) >= 1.0e3
          ? (Math.abs(Number(num)) / 1.0e3).toFixed(2) + " K"
          : Math.abs(Number(num));
  }

  const formatMinutesToHours = (minutes: number) => {
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hrs && mins) return `${hrs}h ${mins}m`;
    if (hrs) return `${hrs}h`;
    return `${mins}m`;
  };

  const navigate = useNavigate();

  const tutorStats = [
    {
      icon: <People className="svg_icn" />,
      title: "Profile Views",
      value: `${data?.profileViews || "-"}`,
      change: 12,
      color: "#05a633",
    },
    {
      icon: <School className="svg_icn" />,
      title: "Followers",
      value: `${data?.followers || "-"}`,
      change: 8,
      color: "#1976d2",
    },
    {
      icon: <MonetizationOn className="svg_icn" />,
      title: "Total Earnings",
      value: `${
        data?.tutorEarning
          ? formatRevenue(data?.tutorEarning[0]?.totalEarning)
          : "0"
      }`,
      change: 15,
      color: "#ff9800",
    },
    {
      icon: <Star className="svg_icn" />,
      title: "Average Rating",
      value: `${data?.averageRating?.toFixed(1)}/(5)`,
      change: 0.5,
      color: "#9c27b0",
    },
  ];

  const classStats = [
    {
      icon: <People className="svg_icn" />,
      title: "Active Students",
      value: `${data?.activeStudents || "0"}`,
      change: 8,
      color: "#05a633",
    },
    {
      icon: <School className="svg_icn" />,
      title: "Total Classes",
      value: `${data?.totalClasses || "0"}`,
      change: 12,
      color: "#1976d2",
    },
    {
      icon: <School className="svg_icn" />,
      title: "Hybrid Classes",
      value: `${data?.hybridClasses || "0"}`,
      change: 12,
      color: "#1976d2",
    },
    {
      icon: <School className="svg_icn" />,
      title: "Offline Classes",
      value: `${data?.offlineClasses || "0"}`,
      change: 12,
      color: "#1976d2",
    },
    {
      icon: <School className="svg_icn" />,
      title: "Online Classes",
      value: `${data?.onlineClasses || "0"}`,
      change: 12,
      color: "#1976d2",
    },
    {
      icon: <MonetizationOn className="svg_icn" />,
      title: "Average Duration",
      value: `${
        data?.averageDuration
          ? formatMinutesToHours(data?.averageDuration?.toFixed(0))
          : "0"
      }`,
      change: 15,
      color: "#ff9800",
    },
    // {
    //   icon: <MonetizationOn />,
    //   title: "Monthly Revenue",
    //   value: `${data?.averageDuration?.toFixed(2) || "0"}`,
    //   change: 15,
    //   color: "#ff9800",
    // },
    // {
    //   icon: <CheckCircle />,
    //   title: "Completion Rate",
    //   value: "92%",
    //   change: 2,
    //   color: "#9c27b0",
    // },
  ];

  const dashboardStats = [
    // Tutors section
    {
      icon: <SchoolIcon className="svg_icn" />,
      title: "Total Tutors",
      value: data?.totalTutors?.toString() || "0",
      onClick: () => navigate("/manage-tutors", { state: 0 }),
    },
    {
      icon: <SchoolIcon className="svg_icn" />,
      title: "Accepted Tutors",
      value: data?.acceptedTutors?.toString() || "0",
      onClick: () => navigate("/manage-tutors", { state: 0 }),
    },
    {
      icon: <SchoolIcon className="svg_icn" />,
      title: "Verified Tutors",
      value: data?.verifiedTutors?.toString() || "0",
      onClick: () => navigate("/manage-tutors", { state: 0 }),
    },
    {
      icon: <SchoolIcon className="svg_icn" />,
      title: "Rejected Tutors",
      value: data?.rejectedTutors?.toString() || "0",
      onClick: () => navigate("/manage-tutors", { state: 2 }),
    },
    {
      icon: <SchoolIcon className="svg_icn" />,
      title: "Deleted Tutors",
      value: data?.deletedTutors?.toString() || "0",
      onClick: () => navigate("/manage-tutors", { state: 3 }),
    },

    // Users section
    {
      icon: <PeopleIcon className="svg_icn" />,
      title: "Total Users",
      value: data?.totalUsers?.toString() || "0",
      onClick: () => navigate("/manageusers", { state: 0 }),
    },
    {
      icon: <SchoolIcon className="svg_icn" />,
      title: "Deleted Users",
      value: data?.deletedUsers?.toString() || "0",
      onClick: () => navigate("/manageusers", { state: 1 }),
    },

    // Bookings section
    {
      icon: <FormatListBulletedIcon className="svg_icn" />,
      title: "Total Bookings",
      value: data?.totalBookings?.toString() || "0",
      onClick: () => navigate("/manage-bookings"),
    },
    {
      icon: <FiberNewIcon className="svg_icn" />,
      title: "New Bookings",
      value: data?.newBookings?.toString() || "0",
      onClick: () => navigate("/manage-bookings", { state: 2 }),
    },
    {
      icon: <HourglassTopIcon className="svg_icn" />,
      title: "Ongoing Bookings",
      value: data?.ongoingBookings?.toString() || "0",
      onClick: () => navigate("/manage-bookings", { state: 0 }),
    },
    {
      icon: <PendingActionsIcon className="svg_icn" />,
      title: "Pending Bookings",
      value: data?.pendingBookings?.toString() || "0",
      onClick: () => navigate("/manage-bookings", { state: 2 }),
    },
    {
      icon: <ThumbUpIcon className="svg_icn" />,
      title: "Approved Bookings",
      value: data?.acceptedBookings?.toString() || "0",
      onClick: () => navigate("/manage-bookings", { state: 0 }),
    },
    {
      icon: <ThumbDownIcon className="svg_icn" />,
      title: "Rejected Bookings",
      value: data?.rejectedBookings?.toString() || "0",
      onClick: () => navigate("/manage-bookings", { state: 3 }),
    },
    {
      icon: <CheckCircleIcon className="svg_icn" />,
      title: "Completed Bookings",
      value: data?.completedBookings?.toString() || "0",
      onClick: () => navigate("/manage-bookings", { state: 1 }),
    },

    // Revenue section
    {
      icon: <CheckCircleIcon className="svg_icn" />,
      title: "Total number of Hours",
      value: data?.totalNoOfHours
        ? Math.floor(data.totalNoOfHours).toString()
        : "0",
      onClick: null,
    },
    {
      icon: <AttachMoneyIcon className="svg_icn" />,
      title: "Total Revenue",
      value: data?.totalRevenue ? formatRevenue(data.totalRevenue) : "0",
      onClick: () => navigate("/payment"),
    },
    {
      icon: <AttachMoneyIcon className="svg_icn" />,
      title: "Daily Revenue",
      value: data?.todayRevenue ? formatRevenue(data.todayRevenue) : "0",
      onClick: () => navigate("/payment"),
    },
    {
      icon: <QuestionMark className="svg_icn" />,
      title: "Total Inquiry",
      value: data?.totalInquiry ? data?.totalInquiry : "0",
      onClick: () => navigate("/manage-inquiries"),
    },
    {
      icon: <ReportProblem className="svg_icn" />,
      title: "Total Reports",
      value: data?.totalReports ? data?.totalReports : "0",
      onClick: () => navigate("/manage-reported"),
    },
  ];

  const contentStats = [
    {
      icon: <PlayCircle className="svg_icn" />,
      title: "Content Uploaded",
      value: data?.contentUploaded?.toString() || "0",
      change: null, // You can calculate this if you have previous data
      color: "#05a633",
      // route: "/manage-videos",
    },
    {
      icon: <ThumbUp className="svg_icn" />,
      title: "Total Likes",
      value: data?.totalLikes?.toString() || "0",
      change: null,
      color: "#1976d2",
      // route: "/manage-videos",
    },
    {
      icon: <Comment className="svg_icn" />,
      title: "Comments",
      value: data?.comments?.toString() || "0",
      change: null,
      color: "#ff9800",
      // route: "/manage-videos",
    },
    {
      icon: <MonetizationOn className="svg_icn" />,
      title: "Gift Tips",
      value: data?.giftTips ? formatRevenue(data.giftTips) : "0",
      change: null,
      color: "#9c27b0",
      // route: "/manage-videos",
    },
    {
      icon: <PlayCircle className="svg_icn" />, // You might want a different icon for teasers
      title: "Teasers",
      value: data?.teaserCount?.toString() || "0",
      change: null,
      color: "#00bcd4",
      route: "/manage-videos",
    },
    {
      icon: <PlayCircle className="svg_icn" />, // You might want a different icon for short videos
      title: "Short Videos",
      value: data?.shortVideoCount?.toString() || "0",
      change: null,
      color: "#607d8b",
      route: "/manage-short-video",
    },
    {
      icon: <Forum className="svg_icn" />, // Assuming you have a Forum icon
      title: "Forums",
      value: data?.forumCount?.toString() || "0",
      change: null,
      color: "#795548",
      route: "/manage-forum",
    },
    {
      icon: <PostAdd className="svg_icn" />, // Assuming you have a PostAdd icon
      title: "Posts",
      value: data?.postCount?.toString() || "0",
      change: null,
      color: "#f44336",
      route: "/manage-post",
    },
    // {
    //   icon: <TrendingUp />, // For approval rate
    //   title: "Approval Rate",
    //   value: `${data?.approvalRate?.toFixed(2) || "0"}%`,
    //   change: null,
    //   color: "#4caf50",
    //   // route: "/manage-videos",
    // },
    {
      icon: <Visibility className="svg_icn" />, // For average views
      title: "Avg Views",
      value: data?.avgViews?.toFixed(2) || "0",
      change: null,
      color: "#2196f3",
      // route: "/manage-videos",
    },
    // {
    //   icon: <Group />, // For engagement rate
    //   title: "Engagement Rate",
    //   value: `${data?.engagementRate?.toFixed(2) || "0"}%`,
    //   change: null,
    //   color: "#ff5722",
    //   route: "/manage-videos",
    // },
  ];

  const ratingDistributionData = {
    labels: data?.ratingCounts?.map(
      (item: { _id: string }) => item?._id.replace(/_star/, "⭐")
    ),

    datasets: [
      {
        data: data?.ratingCounts?.map(
          (item: { _id: string; count: number }) => item?.count
        ),

        backgroundColor: [
          "#05a633", // green
          "#8bc34a", // light green
          "#ffeb3b", // yellow
          "#ff9800", // orange
          "#f44336", // red

          // Additional 10 vibrant colors:
          "#3f51b5", // indigo
          "#2196f3", // blue
          "#00bcd4", // cyan
          "#009688", // teal
          "#4caf50", // medium green
          "#cddc39", // lime
          "#ffc107", // amber
          "#e91e63", // pink
          "#9c27b0", // purple
          "#673ab7", // deep purple
        ],
      },
    ],
  };

  const classTypeData = {
    labels: ["Hybrid Classes", "Offline Classes", "Online Classes"],
    datasets: [
      {
        data: [
          data?.hybridClasses || 0,
          data?.offlineClasses || 0,
          data?.onlineClasses || 0,
        ],
        backgroundColor: ["#05a633", "#1976d2", "#ff9800"],
      },
    ],
  };

  // Chart data
  const videoPerformanceData = {
    labels: ["Teasers", "Shorts", "Forums", "Posts"],
    datasets: [
      {
        label: "Total",
        data: [
          data?.teaserCount,
          data?.shortVideoCount,
          data?.forumCount,
          data?.postCount,
        ],
        backgroundColor: [
          "#05a633", // green
          "#8bc34a", // light green
          "#4caf50", // medium green
          "#009688", // teal
          "#00bcd4", // cyan

          // Additional 10 vibrant colors:
          "#3f51b5", // indigo
          "#f44336", // red
          "#2196f3", // blue
          "#ffeb3b", // yellow
          "#cddc39", // lime
          "#ffc107", // amber
          "#ff9800", // orange
          "#e91e63", // pink
          "#9c27b0", // purple
          "#673ab7", // deep purple
        ],
      },
    ],
  };

  return (
    <div className="main_loyout graphs_dash">
      <div className="dashboard">
        <h1 className="mn_hdng">Dashboard</h1>
        <FormControl>
          <NativeSelect
            defaultValue={selectedType5}
            onChange={handleChange5}
            inputProps={{
              name: "report",
              id: "uncontrolled-native",
            }}
          >
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
            <option value="yearly">Yearly</option>
            <option value="">All Time</option>
          </NativeSelect>
        </FormControl>
      </div>

      <Card
        className="cards"
        sx={{
          mb: 2,
        }}
      >
        <Box className="custom_tabs">
          <Box className="flx_sc">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Overall" {...a11yProps(0)} />
              <Tab label="Tutors" {...a11yProps(1)} />
              <Tab label="Classes" {...a11yProps(2)} />
              <Tab label="Geners" {...a11yProps(3)} />
            </Tabs>
          </Box>
        </Box>
      </Card>
      <CustomTabPanel value={value} index={0}>
        <Grid container spacing={2} className="dashGrid">
          {dashboardStats.map((stat, index) => (
            <Grid item lg={3} md={3} sm={6} xs={12} key={index}>
              <Item
                className="cards dashGrid_item"
                onClick={stat.onClick || undefined}
              >
                {stat.icon}
                <div>
                  <h3>{stat.title}</h3>
                  <h4 className="mn_hdng">{stat.value}</h4>
                </div>
              </Item>
            </Grid>
          ))}
        </Grid>

        <Grid container spacing={2} className="dashGraph" sx={{ pt: 4 }}>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <Item className="cards dashGraph_item">
              <h2 className="mn_hdng">
                Total Users
                <FormControl>
                  <div>
                    <Button
                      sx={{ margin: "5px" }}
                      className="btn btn_primary"
                      onClick={handleExportUserCsv}
                    >
                      <FileDownloadIcon /> Export CSV
                    </Button>
                    <NativeSelect
                      defaultValue={selectedType1}
                      onChange={handleChange1}
                      inputProps={{
                        name: "report",
                        id: "uncontrolled-native",
                      }}
                    >
                      <option value="daily">Daily</option>
                      <option value="weekly">Weekly</option>
                      <option value="monthly">Monthly</option>
                      <option value="yearly">Yearly</option>
                    </NativeSelect>
                  </div>
                </FormControl>
              </h2>
              <LineChart data={graphUsersData} />
            </Item>
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <div className="cards dashGraph_item">
              <h2 className="mn_hdng">
                Total Tutors
                <FormControl>
                  <div>
                    <Button
                      sx={{ margin: "5px" }}
                      className="btn btn_primary"
                      onClick={handleExportTutorCsv}
                    >
                      <FileDownloadIcon /> Export CSV
                    </Button>
                    <NativeSelect
                      defaultValue={selectedType2}
                      onChange={handleChange2}
                      inputProps={{
                        name: "report",
                        id: "uncontrolled-native",
                      }}
                    >
                      <option value="daily">Daily</option>
                      <option value="weekly">Weekly</option>
                      <option value="monthly">Monthly</option>
                      <option value="yearly">Yearly</option>
                    </NativeSelect>
                  </div>
                </FormControl>
              </h2>
              <LineChart data={graphAdvertisersData} />
            </div>
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <div className="cards dashGraph_item">
              <h2 className="mn_hdng">
                Total Bookings
                <FormControl>
                  <div>
                    <Button
                      sx={{ margin: "5px" }}
                      className="btn btn_primary"
                      onClick={handleExportBookingCsv}
                    >
                      <FileDownloadIcon /> Export CSV
                    </Button>
                    <NativeSelect
                      defaultValue={selectedType3}
                      onChange={handleChange3}
                      inputProps={{
                        name: "report",
                        id: "uncontrolled-native",
                      }}
                    >
                      <option value="daily">Daily</option>
                      <option value="weekly">Weekly</option>
                      <option value="monthly">Monthly</option>
                      <option value="yearly">Yearly</option>
                    </NativeSelect>
                  </div>
                </FormControl>
              </h2>
              <LineChart data={graphRevenueData} />
            </div>
          </Grid>
          {/* <Grid item lg={6} md={6} sm={6} xs={12}>
          <Item className="cards dashGraph_item">
            <h2 className="mn_hdng">Total Downloads</h2>
            <LineChart data={graphDownloadsData} />
          </Item>
        </Grid> */}
        </Grid>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Grid container spacing={2} className="dashGrid">
          {tutorStats?.map((stat) => (
            <Grid item lg={3} md={3} sm={6} xs={12}>
              <Item
                className="cards dashGrid_item"
                onClick={() => navigate("/manage-tutors", { state: 0 })}
              >
                {stat?.icon}
                {/* <SchoolIcon className="svg_icn" /> */}
                <div>
                  <h3>{stat?.title}</h3>
                  <h4 className="mn_hdng">{stat?.value || "-"}</h4>
                </div>
              </Item>
            </Grid>
          ))}
        </Grid>
        <Grid spacing={2} className="dashGraph" container mt={3}>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <div className="cards dashGraph_item">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h2 className="mn_hdng">Follower Growth</h2>
                <FormControl>
                  <div>
                    {/* <Button
                      sx={{ margin: "5px" }}
                      className="btn btn_primary"
                      // onClick={handleExportBookingCsv}
                    >
                      <FileDownloadIcon /> Export CSV
                    </Button> */}
                    <NativeSelect
                      defaultValue={selectedType6}
                      onChange={handleChange6}
                      inputProps={{
                        name: "report",
                        id: "uncontrolled-native",
                      }}
                    >
                      <option value="daily">Daily</option>
                      <option value="weekly">Weekly</option>
                      <option value="monthly">Monthly</option>
                      <option value="yearly">Yearly</option>
                    </NativeSelect>
                  </div>
                </FormControl>
              </div>
              <LineChart data={graphFollowerData} />
            </div>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <Box
              sx={{
                p: 3,
                bgcolor: "background.paper",
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                <Star sx={{ verticalAlign: "middle", mr: 1 }} />
                Rating Distribution
              </Typography>
              <LineChart
                data={ratingDistributionData}
                type="pie"
                options={{ plugins: { legend: { position: "right" } } }}
              />
            </Box>
          </Grid>

          {/* <TutorsTab /> */}
        </Grid>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Grid container spacing={2} className="dashGrid">
          {classStats?.map((stat) => (
            <Grid item lg={3} md={3} sm={6} xs={12}>
              <Item
                className="cards dashGrid_item"
                onClick={() => navigate("/manage-classes", { state: 0 })}
              >
                {stat?.icon}
                {/* <SchoolIcon className="svg_icn" /> */}
                <div>
                  <h3>{stat?.title}</h3>
                  <h4 className="mn_hdng">{stat?.value || "-"}</h4>
                </div>
              </Item>
            </Grid>
          ))}
        </Grid>
        <Grid spacing={2} className="dashGraph" container mt={3}>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                p: 3,
                bgcolor: "background.paper",
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                <TrendingUp sx={{ verticalAlign: "middle", mr: 1 }} />
                Class Type Distribution
              </Typography>
              <Divider sx={{ my: 2 }} />
              <LineChart
                data={classTypeData}
                type="doughnut"
                options={{ plugins: { legend: { position: "right" } } }}
              />
            </Box>

            {/* <ClassesTab /> */}
          </Grid>
        </Grid>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <Grid container spacing={2} className="dashGrid">
          {contentStats?.map((stat) => (
            <Grid item lg={3} md={3} sm={6} xs={12}>
              <Item
                className="cards dashGrid_item"
                onClick={() => {
                  if (stat?.route) navigate(stat?.route, { state: 0 });
                }}
              >
                {stat?.icon}
                {/* <SchoolIcon className="svg_icn" /> */}
                <div>
                  <h3>{stat?.title}</h3>
                  <h4 className="mn_hdng">{stat?.value || "-"}</h4>
                </div>
              </Item>
            </Grid>
          ))}
        </Grid>
        <Grid spacing={2} className="dashGraph" container mt={3}>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                p: 3,
                bgcolor: "background.paper",
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                <Equalizer sx={{ verticalAlign: "middle", mr: 1 }} />
                Video Types
              </Typography>
              {/* <Divider sx={{ my: 2 }} /> */}
              <LineChart
                data={videoPerformanceData}
                type="bar"
                options={{
                  scales: { y: { beginAtZero: true } },
                  plugins: { legend: { display: false } },
                }}
              />
            </Box>
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <div className="cards dashGraph_item">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h2 className="mn_hdng">Views</h2>
                <FormControl>
                  <div>
                    {/* <Button
                      sx={{ margin: "5px" }}
                      className="btn btn_primary"
                      // onClick={handleExportBookingCsv}
                    >
                      <FileDownloadIcon /> Export CSV
                    </Button> */}
                    <NativeSelect
                      defaultValue={selectedType7}
                      onChange={handleChange7}
                      inputProps={{
                        name: "report",
                        id: "uncontrolled-native",
                      }}
                    >
                      <option value="daily">Daily</option>
                      <option value="weekly">Weekly</option>
                      <option value="monthly">Monthly</option>
                      <option value="yearly">Yearly</option>
                    </NativeSelect>
                  </div>
                </FormControl>
              </div>
              <LineChart data={graphViewsData} />
            </div>
          </Grid>
          {/* <GenersTab /> */}
        </Grid>
      </CustomTabPanel>
    </div>
  );
};

export default DashBoard;
